<template>
    <el-dialog
    title=""
    :visible.sync="dialogVisible"
    :close-on-click-modal='false'
    :close-on-press-escape='false'
    :before-close="hide"
    width="400px">
    <p style="textAlign: center;fontSize: 18px;">确定选购该应用？</p>
    <!-- <el-select v-model="value" style="width: 360px" placeholder="请选择">
        <el-option
        v-for="item in options"
        :key="item.value"
        size="small"
        :label="item.label"
        :value="item.value">
        </el-option>
    </el-select> -->
    <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="sure">确 定</el-button>
    </span>
    </el-dialog>
  
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: true,
      options: [
        {
          label: '绿城',
          value: 1
        },
        {
          label: '联通',
          value: 2
        }
      ],
      value: 1
    }
  },
  computed: {},
  methods: {
    sure() {
      if (this.value) {
        this.$emit('submit', this.value)
        this.$emit('hide')
      } else {
        this.$message({
          message: '请选择发布对象',
          type: 'warning'
        })
      }
    },
    hide() {
      this.$emit('hide')
    }
  },
  mounted() {}
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppList/selectType.vue